<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        应急机构组织
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <div class="ml20  f18 blue cursor"><i class="el-icon-back" @click="$router.back()">返回</i></div>
    <div class="common-page common-body">
      <div class="flex" style="justify-content: flex-end">
        <!-- <div class="btn ml10" @click="addList()">
          <i class="icon-tr-newly-added"></i>新增
        </div> -->
      </div>
      <div class="common-page common-list">
        <table class="common-table mt20">
          <thead>
            <tr class="mt10">
              <th style="width:15%">应急组织</th>
              <th>短信内容</th>
              <!-- <th>操作</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td class="common-add"><el-input v-model="item.zuzhi_name"></el-input></td>
              <td class="common-add"><el-input v-model="item.plan_neirong"></el-input></td>
              <!-- <td class="td-btn">

                <a class="clear-data" @click="del(index)">
                  <i class="icon-tr-delete"></i>
                </a>
              </td> -->
            </tr>
          </tbody>
        </table>
        <div class="btn-box center ">
          <el-button type="primary" class="l-btn ml20 mt20" @click="$router.back()">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [{ start_time: "", groups: "", z_status: 1 }],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    onSubmit() {
      //    return
      this.$post("/xuncha/xctimeadd", { get_time: this.list }).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
									message: '操作成功',
									type: 'success',
									duration: 700,
								});
        this.$router.back();
      });
    },

    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$post("/drill/grouplist").then((res) => {
        var list = res.data;
        this.$post("/drill/notelist").then((Res) => {
          Res.data.map((item) => {
            list.map((it, ind) => {
              if (it.note_id == item.plan_id) {
                it.plan_neirong = item.plan_neirong;
                list.splice(ind, it);
              }
            });
          });
        });
        this.list = list;
      });
    },
    del(index) {
      this.list.splice(index, 1);
    },
    addList() {
      this.list.push({ start_time: "", z_status: 1 });
    },
  },
};
</script>

<style scoped></style>
